<template>
    <div class="payment-plan-list-item-wrapper">
        <RadioLikeCard :is-selected="isSelected"
            class="payment-plan-list-item">
            <span class="payment-plan-list-item__name">{{ name }}</span>
            <Price :price="price"
                type="small" />
            <span class="payment-plan-list-item__description">{{ description }}</span>
        </RadioLikeCard>
        <div v-if="includesTrial" class="payment-plan-list-item__trial-banner">
            14-day free trial!
        </div>
    </div>
</template>
<script>
import Price from '@/features/agency/common/Price'
import RadioLikeCard from './common/RadioLikeCard.vue';
export default {
    name: 'PaymentPlanListItem',
    props: {
        name: {
            type: String,
            required: true
        },
        price: {
            type: Number,
            required: true
        },
        description: {
            type: String,
            required: true
        },
        isSelected: {
            type: Boolean,
            default: false
        },
        includesTrial: {
            type: Boolean,
            default: false
        }
    },
    components: {
        Price,
        RadioLikeCard
    }
}
</script>
<style lang="scss" scoped>
.payment-plan-list-item-wrapper {
    position: relative;
    padding-top: 12px; /* Add space for the banner that extends above */
}

.payment-plan-list-item {
    position: relative;
    display: flex;
    flex-direction: column;
    gap: 8px;
    cursor: pointer;

    &__name {
        color: $rfx-text-dark-mid-contrast;
        font-size: 16px;
    }

    &__description {
        color: $rfx-text-dark-mid-contrast;
        font-size: 14px;
        line-height: 20px;
    }

    &__radio {
        display: none;
    }

    &__trial-banner {
        position: absolute;
        top: 2px;
        right: 10%;
        background-color: $rfx-dark-purple; /* Purple color */
        color: white;
        font-size: 12px;
        font-weight: 400;
        padding: 4px 8px;
        border-radius: 4px;
        white-space: nowrap;
        z-index: 10;
    }
}
</style>